export default "__VITE_ASSET__9bdcf4b8__"